const STORAGE_KEY = 'restaurant.pos.token'

/**
 * POS cihaz token'ı saklaması.
 *
 * `localStorage` seçildi, `sessionStorage` değil — yönetim panelinin
 * tersine. POS bir **cihazdır**: servis boyunca açık kalır, tarayıcı
 * çökebilir, tablet uyuyabilir ve çevrimdışıyken yeniden giriş yapılamaz.
 * Sekme kapandığında oturumun düşmesi, garsonu servis ortasında parolasını
 * hatırlamak zorunda bırakırdı.
 *
 * Bunun bedeli, token'ın cihazda kalıcı durmasıdır. Karşılığı cihaz başına
 * iptal edilebilir olması (ADR-002): kaybolan tablet tek bir token
 * iptaliyle kapatılır.
 */
export function readToken(): string | null {
  return globalThis.localStorage?.getItem(STORAGE_KEY) ?? null
}

export function writeToken(token: string): void {
  globalThis.localStorage?.setItem(STORAGE_KEY, token)
}

export function clearToken(): void {
  globalThis.localStorage?.removeItem(STORAGE_KEY)
}
